import { FC } from 'react'
import { useDispatch } from 'react-redux'

import { openModal } from 'store/actions/modals'
import { t } from 'translations'

import { Button as MerinioButton } from 'ui'

type Actiontype = {
  text: string
  header?: string
  onClick?: () => void
  remove?: () => void
  link?: string
  devAction?: boolean
}

const ActionsModalButton: FC<{ actions: Actiontype[] }> = ({ actions }) => {
  const dispatch = useDispatch()

  // Handle if the user is lacking permissions for all actions (no empty dropdown)
  const validActions = actions.filter(Boolean)
  if (!validActions.length) return null

  return (
    <>
      <MerinioButton
        color="secondary"
        size="small"
        className="text-nowrap"
        type="button"
        onClick={() =>
          dispatch(
            openModal('ActionsModal', {
              actions: validActions
            })
          )
        }
        outlined
      >
        <i className="fas fa-bars" />
        <span className="d-none d-md-inline ml-2">{t(`components.ACTIONS`)}</span>
      </MerinioButton>
    </>
  )
}

export default ActionsModalButton
